import { createReducer } from "redux-starter-kit";
import {
  startLoadTitlesAction,
  endLoadTitlesAction,
  titlesFailLoadAction,
  filterKeywordEnteredAction,
  delTitleStartAction,
  startCreateAction,
  endCreateAction,
  showCreateAction,
  hideCreateAction,
  editTitleAction,
  editTitleStartLoadAction,
  editTitleEndLoadAction,
  editTitleCompleteAction,
  recoverTitlesAction
} from "../actions/titleList";

const INIT_STATE = {
  loaded: false,
  titles: [],
  errMsg: null,
  keyword: "",
  isCreating: false,
  showCreateModal: false,
  edittingTitleID: null,
  editLoading: false
};

const titleList = createReducer(INIT_STATE, {
  [startLoadTitlesAction]: (state, action) => {
    state.loaded = false;
    state.titles = [];
    state.errMsg = null;
  },
  [endLoadTitlesAction]: (state, action) => {
    state.loaded = true;
    state.titles = action.payload.titles;
    state.errMsg = null;
  },
  [titlesFailLoadAction]: (state, action) => {
    state.loaded = true;
    state.titles = [];
    state.errMsg = action.payload.errMsg;
  },
  [filterKeywordEnteredAction]: (state, action) => {
    state.keyword = action.payload.keyword;
  },
  [delTitleStartAction]: (state, action) => {
    state.titles = state.titles.filter(title => {
      return title.id !== action.payload.titleID;
    });
  },
  [startCreateAction]: (state, action) => {
    state.isCreating = true;
  },
  [endCreateAction]: (state, action) => {
    state.isCreating = false;
  },
  [showCreateAction]: (state, action) => {
    state.showCreateModal = true;
  },
  [hideCreateAction]: (state, action) => {
    state.showCreateModal = false;
  },
  [editTitleAction]: (state, action) => {
    if (!state.editLoading) {
      state.edittingTitleID = action.payload.edittingTitleID;
    }
  },
  [editTitleStartLoadAction]: (state, action) => {
    state.editLoading = true;
  },
  [editTitleEndLoadAction]: (state, action) => {
    state.editLoading = false;
  },
  [editTitleCompleteAction]: (state, action) => {
    const filterTitles = state.titles.filter(
      title => title.id === action.payload.id
    );

    if (filterTitles.length > 0) {
      const aTitle = filterTitles[0];
      aTitle.name = action.payload.newName;
    }
  },
  [recoverTitlesAction]: (state, action) => {
    state.titles = action.payload.allTitles;
  }
});

export default titleList;
